import service from '@/api/service/service';
import qs from "qs";

// 我收到的通知
export function getNoticeList(params = {}) {
  return service({
    url: '/api/notification/notice_list_receive.json',
    method: 'get',
    params,
  })
}

// 我发送的通知
export function sendNoticeList(params = {}) {
  return service({
    url: '/api/notification/notice_list.json',
    method: 'get',
    params,
  })
}

// 全部通知
export function allNoticeList(params = {}) {
  return service({
    url: '/api/notification/all_notice_list.json',
    method: 'get',
    params,
  })
}

// 通知详情
export function noticeDetail(params = {}) {
  return service({
    url: '/api/notification/notice_info.json',
    method: 'get',
    params
  })
}

// 通知阅读状态列表
export function userList(params = {}) {
  return service({
    url: '/api/notification/notice_user_list.json',
    method: 'get',
    params
  })
}

// 删除通知
export function deleteNotice(data = {}) {
  return service({
    url: '/api/notification/notice_remove.json',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新增通知
export function addNotice(data = {}) {
  return service({
    url: '/api/notification/notice_add.json',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function knowNotice(data = {}) {
  return service({
    url: '/api/notification/notice_read.json',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 通知阅读状态列表
export function checkNoticeSend(params = {}) {
  return service({
    url: '/api/notification/check_send_notice.json',
    method: 'get',
    params
  })
}

export function pushNotice(data = {}) {
  return service({
    url: '/api/notification/notice_push.json',
    method: 'post',
    data: qs.stringify(data)
  })
}